// note: general import
import * as React from "react";
import { Link } from "react-router-dom";

// note: MUI import
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

function Logout() {
  return (
    <Container>
      <Box component={"section"} sx={{ marginTop: "20%" }}>
        <Stack>
          <Box component={"section"}>
            <Typography variant="body1">
              We appreciate your time on BIMA INVOICE AR. Your session is now
              complete, and it is safe to close this browser window or tab.
            </Typography>
          </Box>
          <Box component={"section"}>
            <Link
              to={"/login"}
              replace={true}
              style={{ fontSize: "12px", color: "rgba(36, 70, 140, 1)" }}
            >
              <Typography color="primary">Log back in</Typography>
            </Link>
          </Box>
        </Stack>
      </Box>
    </Container>
  );
}

export default Logout;
